import { render, staticRenderFns } from "./MedicalRecordDetail.vue?vue&type=template&id=e2f2f292&"
import script from "./MedicalRecordDetail.vue?vue&type=script&lang=js&"
export * from "./MedicalRecordDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports